import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { InjectionDataModel } from '../_models/injection-data-model';
import { InjectionDataRecord } from '../_models/injection-data-record';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-injection-data-list',
  templateUrl: './injection-data-list.component.html',
  styleUrls: ['./injection-data-list.component.css']
})
export class InjectionDataListComponent implements OnInit {

  public displayedColumns: string[] = ['InjectionDate', 'InjectionPressureAveragePsig', 'InjectionPressureMaxPsig', 'VolumeInjectedBbl', 'TotalVolumeInjectedMcf', 'AnnulusPressureNumReadings', 'AnnulusPressureMinPsig', 'AnnulusPressureMaxPsig', 'DateRowAdded'];

  dataSource: MatTableDataSource<InjectionDataRecord> = new MatTableDataSource<InjectionDataRecord>(null);


  @Input() dateMode: string = "monthly";
  @Input() injectionDataModel: InjectionDataModel;
  @ViewChild(MatTable) matTable: MatTable<any>;

  constructor() {

  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh() {
    if (this.injectionDataModel != null && this.injectionDataModel.InjectionRows != null) {
      this.dataSource.data = (<any> this.injectionDataModel.InjectionRows);
    }
  }
}
